module.exports = __webpack_public_path__ + "img/law-book.5b6b3e81.png";